export default __webpack_public_path__ + "static/peter-6bb40b3dff8213d5707223592535014a.jpg";